export default __webpack_public_path__ + "static/media/menu-burger.de42e128.svg";